module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "py-0 pr-0",
          attrs: {
            "slot": "activator",
            "small": "",
            "outlined": "",
            "outline": ""
          },
          on: {
            "click": _vm.get
          },
          slot: "activator"
        }, on), [_vm._v("\n      🎉 Birthdays\n      "), _c('v-btn', {
          staticClass: "pa-0",
          attrs: {
            "small": "",
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    attrs: {
      "width": "350"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 pb-3",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('titles.today')))]), _vm._v(" "), _vm._l((_vm.birthdaysToday), function(person) {
    return (person.patient) ? _c('v-list-tile', {
      key: ("today-" + (person.relationship_id)),
      attrs: {
        "to": ("/clients/r/" + (person.relationship_id))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(person.patient.first_name) + " " + _vm._s(person.patient.last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.getString(person.patient.date_of_birth)) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.request.loading && _vm.birthdaysToday.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('nothing.today')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('titles.month')))]), _vm._v(" "), _vm._l((_vm.birthdays), function(person) {
    return (person.patient) ? _c('v-list-tile', {
      key: ("month-" + (person.relationship_id)),
      attrs: {
        "to": ("/clients/r/" + (person.relationship_id))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(person.patient.first_name) + " " + _vm._s(person.patient.last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.getString(person.patient.date_of_birth)) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.request.loading && _vm.birthdays.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('nothing.thismonth')) + "\n          ")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1006d1a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/BirthdayBar.vue
// module id = 1328
// module chunks = 9